import React from "react";
import styles from "./columns.module.css";

const Columns = ({ children }) => {
  return <div className={styles.splitEvenly}>{children}</div>;
};

export default Columns;
